import backend from '../../components/utils/backend'

export default {
  state: {
    users: {},
    sfmcUsers: {}
  },
  mutations: {
    'SET_USERS': function (state, users) {
      state.users = users
        .reduce((total, current) => {
          total[current.sfmcId + ''] = current
          return total
        }, {})
    },
    'SET_SFMC_USERS': function (state, users) {
      state.sfmcUsers = users
        .reduce((total, current) => {
          total[current.sfmcId + ''] = current
          return total
        }, {})
    },
    'UPDATE_USER': function (state, user) {
      state.users[user.sfmcId + ''] = user
    }
  },
  actions: {
    getUsers ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = (await backend.get('/api/v1/user', rootGetters['session/accessToken']))
          if (response.statusCode !== 200) {
            console.error('Error during read', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            commit('SET_USERS', response.body)
            resolve(response.body)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    getSfmcUsers ({ commit, rootGetters }) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = (await backend.get('/api/v1/sfmcUser', rootGetters['session/accessToken']))
          if (response.statusCode !== 200) {
            console.error('Error during read', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            if(user){
              resolve(response.body)
            }
            else{
              commit('SET_SFMC_USERS', response.body)
              resolve(response.body)
            }
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    getSfmcUserId ({ commit, rootGetters },accountToSearch) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = (await backend.get(`/api/v1/sfmcUser/${accountToSearch.email}`, rootGetters['session/accessToken']))
          if (response.statusCode !== 200) {
            console.error('Error during read', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            resolve(response.body)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    updateUser ({ commit, rootGetters }, user) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.put(`/api/v1/user/${user.sfmcId}`, rootGetters['session/accessToken'], user)
          if (response.statusCode !== 200) {
            console.error('Error during read', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            commit('UPDATE_USER', response.body)
            resolve(response.body)
          }
        } catch (error) {
          reject(error)
        }
      })
    },
    newUser ({ commit, rootGetters }, user) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.post(`/api/v1/user/${user.sub}`, rootGetters['session/accessToken'], user)
          if (response.statusCode !== 200) {
            console.error('Error during insert', response.body)
            throw new Error(response.body.moreInformation)
          } else {
            const responseGet = (await backend.get('/api/v1/user', rootGetters['session/accessToken']))
            if (responseGet.statusCode !== 200) {
              console.error('Error during read', responseGet.body)
              throw new Error(responseGet.body.moreInformation)
            } else {
              commit('SET_USERS', responseGet.body)
              resolve(responseGet.body)
            }
        }
        } catch (error) {
          reject(error)
        }
      })
    },
    //modifica salvo 10/10/2024
    deleteUser ({ commit, rootGetters }, user) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await backend.delete(`/api/v1/user/${user.sfmcId}`, rootGetters['session/accessToken'])
          if (response.statusCode !== 200) {
            console.error('Error during read', response.body)
            throw new Error(response.body.moreInformation)
          } else {
              const responseGet = (await backend.get('/api/v1/user', rootGetters['session/accessToken']))
              if (responseGet.statusCode !== 200) {
                console.error('Error during read', responseGet.body)
                throw new Error(responseGet.body.moreInformation)
              } else {
                commit('SET_USERS', responseGet.body)
                resolve(responseGet.body)
              }
          }
        } catch (error) {
          reject(error)
        }
      })
    }
  },
  getters: {
    userList: state => Object.values(state.users),
    sfmcUserList: state => Object.values(state.sfmcUsers)
  },
  namespaced: true
}
